import _ from 'lodash';
import { createSelector } from 'reselect';
import * as fromState from '../../../state/reducers';
import * as entitySelectors from '../../../state/selectors/entity';
import { ENTITY_TYPE } from '../../../utils/constants';

export default createSelector(
  [
    state => fromState.getAll(state, ENTITY_TYPE.UNIT),
    state => entitySelectors.getUnitPaths(state),
    (state, { geoShape }) => geoShape
  ],
  (
    allUnits,
    unitPaths,
    geoShape
  ) => _.chain(allUnits)
    .toPairs()
    .filter(([id, unit]) => !geoShape || unit.settings.geoShape)
    .map(([id, unit]) => ({
      key: id,
      text: geoShape
        ? unit.description || unit.name
        : unitPaths[id],
      value: id
    }))
    .sortBy('text')
    .value()
);